import React from 'react';
import { createTheme, ThemeProvider } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import AppRouter from '../../app/routes/Router';
import Vertical from './Vertical/index';
import Horizontal from './Horizontal/index';
import greenTheme from '../themes/greenTheme';
import { MenuDataProvider } from './MenuDataProvider';
import { ShellAppContextProvider } from '../../features/shell/context/ShellAppContextProvider';
import { ShellSessionGate } from '../ShellSessionGate';
import { ShellWizardGate } from '../ShellWizardGate';
import { appInIframe, getAdminProductId, wsClient } from '../../util/appUtils';
import { TelemetryRouteTracker } from '../../features/telemetry/TelemetryRouteTracker';
import { ADMIN_LAYOUT_MODES, resolveAdminLayoutMode } from './layoutMode';

const AppLayout = () => {
  const { shopId } = useSelector((store) => store.settings);
  const applyTheme = createTheme(greenTheme);
  const isCompactMode = useSelector(({ app }) => app.isCompactMode);
  const isEmbedded = appInIframe();
  const productId = getAdminProductId();
  const layoutMode = resolveAdminLayoutMode({
    isCompactMode,
    isEmbedded,
  });
  const Layout = layoutMode === ADMIN_LAYOUT_MODES.HORIZONTAL ? Horizontal : Vertical;

  return (
    <ShellAppContextProvider
      cloudClient={wsClient}
      productId={productId}
    >
      <ShellSessionGate>
        <ShellWizardGate>
          <TelemetryRouteTracker />
          <MenuDataProvider shopId={shopId}>
          <Layout>
          <ThemeProvider theme={applyTheme}>
            <AppRouter />
          </ThemeProvider>
          </Layout>
          </MenuDataProvider>
        </ShellWizardGate>
      </ShellSessionGate>
    </ShellAppContextProvider>
  );
};

export default AppLayout;
